import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AlertModule } from '@curbnturf/alert';
import { NGRX_BUCKETS } from '@curbnturf/entities';
import { NetworkModule } from '@curbnturf/network';
import { StatusFacade } from '@curbnturf/status/src/lib/status.facade';
import { StorageModule } from '@curbnturf/storage';
import { UrlControlModule } from '@curbnturf/url-control';
import { UserModule } from '@curbnturf/user';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as authEffects from './+state/auth.effects';
import { authReducer, initialState as authInitialState } from './+state/auth.reducer';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { CognitoService } from './cognito.service';

@NgModule({
  imports: [AlertModule, RouterModule, NetworkModule, StorageModule, UrlControlModule, UserModule],
  providers: [
    AuthService,
    AuthGuard,
    CognitoService,
    StatusFacade,
    provideState(NGRX_BUCKETS.auth, authReducer, {
      initialState: authInitialState,
    }),
    provideEffects(authEffects),
  ],
})
export class AuthModule {}
